import React, { useEffect } from 'react';
import '../../scss/modal.scss'
import { ReactComponent as CloseIcon } from '../../images/cross-icon.svg'

const CenteredPopup = ({ children, isOpen, onClose, icon, buttons, className, disabled }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen])
  if (!isOpen) return null;

  return (
    <div className={`modal-overlay ${className ? className : ''}`} style={{ zIndex: '9999' }}>
      <div className="modal-content">
        <span className="modal-close" onClick={onClose}><CloseIcon /></span>
        {icon && <div className="modal-icon">{icon}</div>}
        <div className="modal-body">{children}</div>
        <div className="modal-footer">
          {buttons && buttons.length > 0 ? <div className={`buttons ${buttons.length > 1 ? 'multi-btns' : ''}`}>
            {buttons.map((button, index) => (
              <button
                key={index}
                disabled={disabled}
                className={`btn btn-primary ${button.className ? button.className : ''} ${disabled ? 'disabledBtnClass' : ''}`}
                onClick={button.onClick}
              >
                {button.label}
              </button>
            ))}</div> : null}
        </div>
      </div>
    </div>
  );
};

export default CenteredPopup;
